import { Markdown } from "components/Form/components/Markdown/Markdown";
import { SecretContent } from "components/Form/components/SecretContent/SecretContent";
import { isEmpty } from "lodash";
import { PropsWithChildren, ReactNode, useMemo } from "react";
import "./LabelledFormElement.scss";

export type LabelledFormElementProps = {
    label?: string;
    description?: string;
    type?: "object" | "array";
    labelClassName?: string;
    isRemoved?: boolean;
    onAdd?: () => void;
    actionButtons?: ReactNode;
    errorMessage?: string;
    elementSchemaStyle?: {
        border?: boolean;
        align?: "VERTICAL" | "HORIZONTAL";
    };
    secret?: boolean;
    isContentButtonAlwaysVisible?: boolean;
};

export const LabelledFormElement = ({
    label,
    description,
    type,
    children,
    labelClassName,
    isRemoved,
    onAdd,
    actionButtons,
    errorMessage,
    elementSchemaStyle,
    secret,
    isContentButtonAlwaysVisible,
}: PropsWithChildren<LabelledFormElementProps>) => {
    const descriptionElement = useMemo(() => {
        if (description == null) return null;
        return <Markdown markdownString={description} className="description" />;
    }, [description]);

    if (isEmpty(label) && isEmpty(description) && isEmpty(children)) return null;
    const errorComponent = errorMessage && <div className="errorMessage">{errorMessage}</div>;
    return (
        <div
            className={`labelledFormElement ${type ?? ""}  ${isRemoved ? "removed" : ""} ${
                errorMessage ? "hasError" : ""
            } ${elementSchemaStyle?.border ? "form-style-border" : ""} ${
                elementSchemaStyle?.align ? `${elementSchemaStyle.align.toLowerCase()}` : "vertical"
            }`}
            onClick={() => isRemoved && onAdd?.()}
        >
            <div className="labelAndDescription">
                <div className="labelContainer">
                    {label !== undefined ? (
                        <div className={`label ${labelClassName ?? ""}`}>{label}</div>
                    ) : null}
                    {actionButtons}
                </div>
                <div className="description">{descriptionElement}</div>
            </div>

            {secret && children ? (
                <SecretContent isButtonAlwaysVisible={isContentButtonAlwaysVisible}>
                    <div className="formElement">{children}</div>
                    {errorComponent}
                </SecretContent>
            ) : (
                <>
                    {children && <div className="formElement">{children}</div>}
                    {errorComponent}
                </>
            )}
        </div>
    );
};
